require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-1-so-2-uc.json") })
        }
      }, "path---photos-professional-1-so-2-uc");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-1-so-2-uc!./.cache/json/photos-professional-1-so-2-uc.json
// module id = 618
// module chunks = 231608221292675